import { Linkedin } from "react-bootstrap-icons";

const APIList = {
  // Authorization
  ADMIN_LOGOUT: "/userlogout/userlogout",
  ADMIN_LOGIN: "/adminlogin/login",

  //Dashboard Data
  DASHBOARD_GET: "/dashboard/getDashboardData",

  // ANalytics data
  ANALYTICS_GET: "/dashboard/getDashboardAnalyticsData",
  ANALYTICS_WALL_DATA: "/dashboard/downloadwallData",
  ANALYTICS_CULTURAL_CLUB_DATA: "/dashboard/downloadwCulturalclubeData",
  ANALYTICS_PEOPLE_DATA: "/dashboard/downloadpeopleFeedData",
  ANALYTICS_SESSION_DATA: "/dashboard/downloadsessionData",
  ANALYTICS_NOTIFICATION_DATA: "/dashboard/downloadNotificationData",
  ANALYTICS_CONTEST_DATA: "/dashboard/downloadcontestData",

  /** Notification */
  GET_ALL_NOTIFICATION: "/notification/getdata",
  ADD_NOTIFICATION: "/notification/save",
  EDIT_NOTIFICATION: "/notification/save",
  DELETE_NOTIFICATION: "/notification/updateDeleteFlagData",

  /** People */
  GET_ALL_PEOPLE: "/people/getall",
  GET_ALL_PEOPLES: "/people/getdata",
  ADD_PEOPLE: "/people/save",
  DELETE_PEOPLE: "/people/updateDeleteFlagData",
  TOGGLE_GOD_MODE: "/peopleStatus/save",
  IMPORT_PEOPLE: "/people/importExcel",

  /* Group */
  ADD_GROUP: "/groupMaster/save",
  GET_ALL_GROUP: "/groupMaster/getall",
  GET_ALL_GROUPS: "groupMaster/getdata",
  EDIT_GROUP: "/groupMaster/save",
  DELETE_GROUP: "/groupMaster/updateDeleteFlagData",
  TOGGLE_GROUP_STATUS: "/groupStatus/save",
  IMPORT_GROUP: "/groupStatus/importExcel",
  GET_GROUP_BY_ID: "/groupMaster/getdatabyid",

  //  gallery

  folder_list: "/galleryfolder/getall",
  add_Folder: "/galleryfolder/save",
  delete_Folder: "/galleryfolder/updateDeleteFlagData",
  Add_media: "/gallerymedia/savemulti",
  gallery_list: "/admingallarymedia/getall",
  delete_gallery: "/gallerymedia/updateDeleteFlagData",
  ViewUserLIkeList: "/admingallarymedia/getdata",
  VIEW_USER: "/admingallarymedia/viewUser",
  DOWNLOAD_MEDIA: "/gallerymedia/downloadImage",
  // TODO:  interchange "/admingallarymedia/getall"  with  "/admingallarymedia/getdata"

  // App_version

  App_version_getall: "/forceupdate/getall",
  add_version: "/forceupdate/save",
  app_version_status: "./forceupdatestatus/save",

  /* Training Quiz */
  GET_ALL_TRAINING_QUIZ_FOLDER: "/quizFolderName/getall",
  ADD_TRAINING_QUIZ_FOLDER: "/quizFolderName/save",
  TOGGLE_TRAINING_QUIZ_FOLDER_STATUS: "/quizFolderStatus/save",
  TOGGLE_TRAINING_QUIZ_FOLDER_SHOW_RESULT: "/quizFolderStatus/save",
  DELETE_TRAINING_QUIZ_FOLDER: "/quizFolderName/updateDeleteFlagData",
  GET_TRAINING_QUIZ_FOLDER_BY_ID: "/quiz/getdatabyid",

  ADD_TRAINING_QUIZ: "/quiz/save",
  DELETE_TRAINING_QUIZ: "/quiz/updateDeleteFlagData",
  TOGGLE_TRAINING_QUIZ_STATUS: "/quizStatus/save",
  GET_SUBMITTED_USERS: "/quizStatus/getdata",

  /** My Connect */

  GET_MAIN_FOLDERS: "/myconnect/getall",
  GET_FILTER_DATA: "/myconnect/getdata",
  EDIT_ITEM: "/myconnectcontent/save",
  ADD_DATA: "/myconnectfolder/save",
  EDIT_DATA: "/myconnect/save",
  ADD_CONNECT: "/myconnect/save",
  GET_FOLDER_DATA: "/myconnectfolder/getall",
  ADD_ITEM: "/myconnectcontent/save",
  DELETE_MAIN_FOLDER: "/myconnect/updateDeleteFlagData",
  DELETE_ITEM: "/myconnectcontent/updateDeleteFlagData",
  DELETE_FOLDER: "/myconnectfolder/updateDeleteFlagData",
  EDIT_MAIN_FOLDER: "/myconnectcontent/save",
  VIEW_COUNT: "analyticcount/getdata",
  DOWNLOAD_VIEW_USER: "userreportdownload/getall",


  /** Training*/
  GET_TRAINING_DATA: "/trainingMaster/getall",
  DELETE_TRAINING_DATA: "/trainingMaster/updateDeleteFlagData",
  CREATE_TRAINING: "/trainingMaster/save",
  EDIT_TRAINING: "/trainingMaster/save",
  TRAINING_STATUS: "/trainingStatus/save",
  GETALL_TRAININING_CONTENT: "/trainingContent/getdata",
  ADD_TRAINING_CONTENT: "/trainingContent/save",
  GET_QUIZ_OPTIONS: "/trainingFolderData/getall",
  DELETE_CONTENT: "/trainingContent/updateDeleteFlagData",
  GET_TRAINING_CONTENT_BY_ID: "/trainingContent/getdatabyid",
  EDIT_CONTENT: "/trainingContent/save",
  GET_CONTENT_BY_ID: "/trainingContent/getdatabyid",
  GET_TRAINING_MASTER_BY_ID: "/trainingMaster/getdatabyid",
  GET_TRAINING_REPORTS: "/trainingMaster/getdata",
  /** Activities */

  /** Quiz */
  ADD_QUIZ_FOLDER_NAME: "/quizFolderName/save",
  EDIT_QUIZ_FOLDER_NAME: "/quizFolderName/save",
  GET_ALL_QUIZ_FOLDER_NAME: "/quizFolderName/getall",
  GET_QUIZ_DETAILS_BY_QUIZ_FOLDER_ID: "/quizFolderName/getdatabyid",
  DELETE_QUIZ_FOLDER_NAME: "/quizFolderName/updateDeleteFlagData",
  CHANGE_QUIZ_FOLDER_STATUS: "/quizFolderStatus/save",
  CHANGE_QUIZ_FOLDER_RESULT: "/quizFolderStatus/save",
  ADD_QUIZ: "/quiz/save",
  DELETE_QUIZ: "/quiz/updateDeleteFlagData",
  GET_QUIZ_BY_FOLDER_ID: "/quiz/getdatabyid",
  CHANGE_QUIZ_STATUS: "/quizStatus/save",
  GET_ALL_USER_QUIZ_DATA: "/quizStatus/getdata",

  /** Photo Challenge */
  ADD_PHOTO_CHALLENGE: "/photochallenge/save",
  EDIT_PHOTO_CHALLENGE: "/photochallenge/save",
  DELETE_PHOTO_CHALLENGE_FOLDER: "/photochallenge/updateDeleteFlagData",
  PHOTO_CHALLENGE_STATUS_UPDATE: "/photochallenge/statusupdate",
  GET_ALL_PHOTO_CHALLENGE: "/photochallenge/getall",
  GET_PHOTO_DETAILS_BY_FOLDER_ID: "/adminphotogallerydata/getall",
  GET_PHOTO_LIKE_DATA: "/adminphotogallerydata/getdata",
  DELETE_PHOTO: "/adminphotogallerydata/updateDeleteFlagData",

  /** Video Challenge */
  ADD_VIDEO_CHALLENGE: "/videochallenge/save",
  EDIT_VIDEO_CHALLENGE: "/videochallenge/save",
  DELETE_VIDEO_CHALLENGE_FOLDER: "/videochallenge/updateDeleteFlagData",
  VIDEO_CHALLENGE_STATUS_UPDATE: "/videochallenge/statusupdate",
  GET_ALL_VIDEOS_CHALLENGE: "/videochallenge/getall",
  GET_VIDEO_DETAILS_BY_FOLDER_ID: "/adminvideogallerydata/getall",
  GET_VIDEO_LIKE_DATA: "/adminvideogallerydata/getdata",
  DELETE_VIDEO: "/adminvideogallerydata/updateDeleteFlagData",

  /** Zigsaw Challenge */
  ADD_ZIGSAW_CHALLENGE: "/zigsawchallenge/save",
  EDIT_ZIGSAW_CHALLENGE: "/zigsawchallenge/save",
  DELETE_ZIGSAW_CHALLENGE_FOLDER: "/zigsawchallenge/updateDeleteFlagData",
  ZIGSAW_CHALLENGE_STATUS_UPDATE: "/zigsawchallenge/statusupdate",
  GET_ALL_ZIGSAW_CHALLENGE: "/zigsawchallenge/getall",
  GET_ZIGSAW_USER_DETAILS: "/userzigsawchallenge/getdata",

  /** Kahoot Challenge */
  ADD_KAHOOT_CHALLENGE: "/kahootChallenge/save",
  EDIT_KAHOOT_CHALLENGE: "/kahootChallenge/save",
  DELETE_KAHOOT_CHALLENGE_FOLDER: "/kahootChallenge/updateDeleteFlagData",
  KAHOOT_CHALLENGE_STATUS_UPDATE: "/kahootChallenge/statusupdate",
  GET_ALL_KAHOOT_CHALLENGE: "/kahootChallenge/getall",

  /** Zoom and Webinar Links */
  ADD_ZOOM_WEBINAR: "/zoomwebinar/save",
  EDIT_ZOOM_WEBINAR: "/zoomwebinar/save",
  GET_ALL_ZOOM_WEBINAR: "/zoomwebinar/getall",
  DELETE_ZOOM_WEBINAR: "/zoomwebinar/updateDeleteFlagData",
  ZOOM_WEBINAR_STATUS_UPDATE: "/zoomwebinar/statusupdate",

  /** Wall */
  ADD_POST: "/newsFeed/save",
  EDIT_POST: "/newsFeed/save",
  GET_ALL_POST: "/newsFeedGet/getdata",
  DELETE_POST: "/newsFeed/updateDeleteFlagData",
  POST_STATUS_UPDATE: "/newsFeedHide/save",
  POST_VIEW: "/newsFeedHide/save",
  DOWNLOAD_IMAGE: "/newsFeed/downloadImage",
  DOWNLOAD_VIDEO: "/newsFeed/downloadVideo",
  VIEW_NEWS_FEED: "/newsFeed/getdatabyid",
  ViewUserList: "/newsFeed/getdatabyid",
  DELETE_REPORT: "/reportPost/updateDeleteFlagData",

  //Survey
  GET_ALL_SURVEY: "/survey/getall",
  ADD_SURVEY: "/survey/save",
  EDIT_SURVEY: "/survey/save",
  DELETE_SURVEY: "/survey/updateDeleteFlagData",
  GET_SURVEY_DATA_BY_TYPE: "/survey/getdata",
  GET_SURVEY_GROUP_DATA: "/groupsurvey/getdata",
  ADD_SURVEY_QUIZ: "/surveyquiz/save",
  GET_QUIZ_DATA_BY_SURVEY_ID: "/surveyquiz/getdatabyid",
  DELETE_SURVEY_QUIZ: "/surveyquiz/updateDeleteFlagData",
  GET_ATTEMPTED_USERS: "/usersurveysubmit/getdata",
  GET_ALL_USER_SURVEY_DATA:"surveystatus/getdata",

  // Cultural Club
  GETALL_CULTURAL_CLUB_DATA: "/culturalGroup/getdata",
  Add_group_cultural_club: "/culturalClubGroup/savemulti",
  TOGGLE_HIDE_UNHIDE: "/newsFeedHide/save",
  // DELETE_POST:"/newsFeed/updateDeleteFlagData",  already defined above under Newsfeed
  GET_ALL_CULTURAL_GROUP: "/culturalClubGroup/getall",
  DOWNLOAD_CULTURAL_CLUB_VIDEOS: "/culturalGroup/downloadVideo",
  DOWNLOAD_CULTURAL_CLUB_PHOTOS: "/culturalGroup/downloadImage",

  DELETE_CULTURAL_CLUB_POST: "/newsFeed/updateDeleteFlagData",

  //leaderboard
  // leaderboard_getall: "/leaderboarddata/getdata",
  LEADERBOARD_GETALL: "/leaderboarddata/getdata",
  LEADERBOARD_COUNT_GETALL: "/leaderboard/getall",
  UPDATE_COUNT: "/leaderboard/save",
  EXTRA_POINT:"/extrapoint/save",
  
  delete_leatherboard: "/leaderboarddata/updateDeleteFlagData",

  // HR Chat
  GET_CHAT_HISTORY: "/adminchathistory/getdata",
  SEND_MESSAGE: "/chat/save",
  GET_CHAT_BY_ID: "/chat/getdatabyid",
  DELETE_CHAT_BY_ID: "/chat/clearchat",
};

export default APIList;
